import { render, staticRenderFns } from "./IssuanceInvoiceView.vue?vue&type=template&id=45557cd8&scoped=true"
import script from "./IssuanceInvoiceView.vue?vue&type=script&lang=js"
export * from "./IssuanceInvoiceView.vue?vue&type=script&lang=js"
import style0 from "./IssuanceInvoiceView.vue?vue&type=style&index=0&id=45557cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45557cd8",
  null
  
)

export default component.exports